module.exports = __webpack_public_path__ + "assets/img/nanjing.87eacdd0.png";